import { PharmacLoadingDots } from '@pharmac/ui'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { ExtranetGradient } from '../../components/extranet/ExtranetGradient'
import { useAuthenticationContext } from '../../features/authentication/useAuthentication'
import { customerQueryKeyFactory } from '../../features/customer/customership.queries'
import { useExtranetPath } from '../../router/useExtranetPath'
import { api } from '../../services/HttpService'
import { isValidInviteToken } from '../../utils/validate-token'

export const JoinCustomerView = () => {
  const createLink = useExtranetPath()
  const [redirect, setRedirect] = useState<boolean>(false)
  const { token } = useParams()

  const { doConsumeToken } = useAuthenticationContext()

  const doCheckToken = async (token: unknown) => {
    if (isValidInviteToken(token)) {
      const result = await api.customers.getInviteTokenInfo(token)

      return result
    }

    return false
  }

  const queryClient = useQueryClient()

  useEffect(() => {
    if (isValidInviteToken(token)) {
      doCheckToken(token).then((info) => {
        if (info) {
          doConsumeToken(token).then((response) => {
            if (response) {
              queryClient
                .invalidateQueries({
                  queryKey: customerQueryKeyFactory.getUserCustomers(),
                })
                .then(() => setRedirect(true))
            }
          })
        }
      })
    }
  }, [token])

  if (redirect) {
    return (
      <Navigate
        to={createLink('root')}
        replace={true}
      />
    )
  }

  return (
    <ExtranetGradient>
      <PharmacLoadingDots />
    </ExtranetGradient>
  )
}
